<template>
<div>
    <div>
        <H2>
        Kalkulator
        </h2>
    </div>    

    <p class="lead">
        Samodzielne przygotowanie nawozów do akwarium
    </p>
    <p>
        Ta strona zawiera kalkulator, który pomoże ustalić składniki nawozu makroelementowego do akwarium. Potrzebne sole można kupić w sklepie chemicznym lub na stronie
        <a href="http://akwanawozy.com.pl">http://akwanawozy.com.pl</a>. Dodatkowych informacji na temat proporcji takiego nawozu można szukać na forach internetowych (polecam
        <a href="http://holenderskie.pl/forum">http://holenderskie.pl/forum</a>).
    </p>
    <p>
        Wszystkie dane przechowywwane są w pamięci przeglądarki (nic nie jest wysyłane sa serwer). Aplikacja działa nawet po odłączeniu od internetu. Aplikacja udostępniona
        jest na licencji, która pozwala na kopiowanie, modyfikowanie i rozpowszechnianie na tych samych zasadach.
    </p>
    
    <div class="tab-content">
        <div v-show="tab=='nawozy'">
            <div class="no-print">
                <h4>Nawozy</h4>
                <div class="md-layout md-gutter">
                    <div class="md-layout-item md-size-50">
                        <md-field>
                                <label for="nazwaNawozu">Nazwa nowego nawozu</label>
                                <md-input name="nazwaNawozu" id="nazwaNawozu" v-model="nazwaNawozu"/>
                        </md-field>
                    </div>
                    <div class="md-layout-item md-alignment-center-center">
                        <span class="btn clickable plate" v-on:click="dodajNawoz()">
                            <md-icon title="Dodaj nawóz">add</md-icon>
                        </span>
                        <span class="btn clickable plate" v-bind:class="{disabled: usunietyNawoz==null}" v-on:click="cofnijUsuniecie()">
                            <md-icon title="Cofnij usunięcie">history</md-icon>
                        </span>                    
                        <span class="btn clickable plate" v-on:click="zapiszDoPliku()">
                            <md-icon title="Zapisz do pliku">save</md-icon>
                        </span>                    
                        <span class="btn clickable plate" v-on:click="wczytajZPliku()"><md-icon title="Wczytaj z pliku">cloud_upload</md-icon></span>
                    </div>
                </div>
                <span v-for="nawoz in nawozy" :key="nawoz.id" class="btn clickable plate md-primary" v-bind:class="{'accent': makro!==null && nawoz.id==makro.id}">
                    <span v-on:click="uzyjNawozu(nawoz)">{{nawoz.nazwa}}</span>   
                    <span>                
                        <md-icon v-on:click.native="usunNawoz(nawoz)" title="usuń nawóz">delete</md-icon>
                    </span>
                </span>               
            </div>

            <div class="" v-if="makro!==null">
                <hr class="no-print" />
                <div class="md-layout md-gutter">
                    <div class="md-layout-item">
                        <md-field>
                            <label for="nazwa">Nazwa nawozu</label>
                            <md-input name="nazwa" id="nazwa" v-model="makro.nazwa"/>
                        </md-field>                        
                        <md-field>
                            <label for="pojemnosc">Pojemność akwarium [l]</label>
                            <md-input name="pojemnosc" id="pojemnosc" type="number" v-model="makro.pojemnosc" v-on:change="przelicz()"/>                            
                        </md-field>
                        <md-checkbox v-model="makro.iloscWszystko" v-on:change="przelicz()">Wszystko na raz</md-checkbox>
                        <md-field v-if="!makro.iloscWszystko">
                            <label for="ilosc">Jednorazowa dawka nowozu [ml]</label>
                            <md-input name="ilosc" id="ilosc" type="number" v-model="makro.ilosc" v-on:change="przelicz()"/>
                        </md-field>
                    </div>
                    <div class="md-layout-item">
                        <div class="md-layout" v-for="skladnik in makro.skladniki" v-bind:key="skladnik.symbol()" >
                            <md-field v-if="skladnik.uzywany">
                                <label :for="skladnik.symbol()"><chemical :value="skladnik.symbol()"></chemical> [g]</label>
                                <md-input type="numeric" :name="skladnik.symbol()" :id="skladnik.symbol()" v-model="skladnik.ilosc" v-on:change="przelicz()"/>
                                <md-icon class="info" v-if="!skladnik.rozpuszczony" title="składnik nie rozpuści się całkowicie">info</md-icon>
                            </md-field>
                        </div>    
                    </div>

                    <div class="md-layout-item">                    
                        <button v-if="makro!==null" class="btn clickable plate" v-on:click="powielNawoz()">Powiel</button>
                        <div>
                            <span v-for="skladnik in makro.skladniki" 
                                v-bind:class="{uzywany: skladnik.uzywany}"
                                :key="skladnik.symbol()" class="btn clickable plate" v-on:click="zmienUzywanie(skladnik)">
                                <chemical :value="skladnik.symbol()"></chemical>                                
                            </span>
                        </div>
                    </div>
                    <div class="md-layout-item">
                        <md-card>
                            <md-card-header>
                                <md-card-header-text>
                                <div class="md-title">Stężenia</div>
                                </md-card-header-text>
                            </md-card-header>
                            <md-card-content>
                                <div class="md-layout" v-if="makro.stezenia.length==0">
                                    <div class="md-layout-item md-size-60"><span class="btn clickable plate">Brak</span></div>
                                    <div class="md-layout-item md-size-40 text-right"><md-icon title="wpisz zawartość składników">help</md-icon></div>
                                </div>                                
                                <div class="md-layout" v-for="stezenie in makro.stezenia" :key="stezenie.symbol">
                                    <div class="md-layout-item md-size-60"><chemical class="btn clickable plate" :value="stezenie.symbol"></chemical></div>
                                    <div class="md-layout-item md-size-40 text-right"><span>{{stezenie.ppm.toFixed(1)}} mg/l</span></div>
                                </div>
                                <div class="md-layout" v-if="gh>0">
                                    <div class="md-layout-item md-size-60"><span class="btn clickable plate">Gh</span></div>
                                    <div class="md-layout-item md-size-40 text-right">
                                        <md-icon title="zwiększenie twardości wody">help</md-icon>
                                        <span class="">+{{gh.toFixed(1)}} &deg;dH</span>
                                    </div>
                                </div> 
                            </md-card-content>                            
                        </md-card>
                    </div>
                </div>                            
            </div>
        </div>
    </div>

</div>
</template>

<script>
import Makro from '../components/makro.js'
import chemical from '../components/chemical.vue'

export default {
    name: 'kalkulator',
    components: {            
        chemical
    },  
    data: function() {        
        return {
            id: 0,
            skladniki : [],
            edytowanySkladnik : null,
            nawozy : [],
            makro : null,
            nazwaNawozu : "",
            tab : "nawozy",
            usunietyNawoz : null,
        }
    },
    created() {
        this.wczytaj();
        this.przelicz();
        window.onbeforeunload = this.zapisz;        
    },
    destroyed() {
        this.zapisz()
    },
    methods: {          
        pokazukryjNieuzywane() {
            if (!this.makro) return;
            this.makro.pokazNieuzywane = !this.makro.pokazNieuzywane;
        },
        dodajNawoz() {
            var makro = new Makro();
            makro.nazwa = this.nazwaNawozu;
            if (makro.nazwa=="")
                makro.nazwa = "brak nazwy";
            makro.id = this.id;
            this.id++;
            this.nawozy.push(makro);
            this.uzyjNawozu(makro);
        },
        usunNawoz(nawoz) {
            var index = this.nawozy.findIndex(x => x.id === nawoz.id);
            if (index>=0)
                this.usunietyNawoz = this.nawozy.splice(index,1)[0];
            if (this.makro!= null && this.makro.id === nawoz.id)
                this.makro = null;
        },
        cofnijUsuniecie() {
            if (this.usunietyNawoz == null) return;
            this.nawozy.push(this.usunietyNawoz);
            this.usunietyNawoz = null;
        },
        uzyjNawozu(nawoz) {
            this.makro = nawoz;
            if (nawoz)
                this.nazwaNawozu = nawoz.nazwa;
            this.przelicz();
        },
        zmienNazwe() {
            if (!this.makro) return;
            this.makro.nazwa = this.nazwaNawozu;
        },
        powielNawoz() {
            if (!this.makro) return;
            var stan = {};
            this.makro.zapisz(stan);
            var nowy = new Makro();
            nowy.wczytaj(stan);
            this.id++;
            nowy.id = this.id;
            this.nawozy.push(nowy);
            this.uzyjNawozu(nowy);
        },
        stezenie(symbol) {
            if (!this.makro) return 0;
            for (var i in this.makro.stezenia) {
                var zmiany = (this.makro.stezenia[i]);
                if (zmiany.symbol === symbol)
                    return zmiany.ppm;
            }
            return 0;
        },
        przeliczGh() {
            this.gh = this.stezenie("CA") / 7.14 + this.stezenie("MG") / 4.3;
        },
        przelicz() {
            window.console.log("przeliczono")
            if (!this.makro) return;
            this.makro.przelicz();        
            this.przeliczGh();        
        },
        zmienUzywanie(skladnik) {
            skladnik.uzywany = !skladnik.uzywany;
            this.przelicz();
        },
        saNieuzywane() {
            if (!this.makro) return false;
            for (var i in this.makro.skladniki) {
                var skladnik = this.makro.skladniki[i];
                if (!skladnik.uzywany)
                    return true;
            }
            return false;
        },
        resetujStan() {
            setTimeout(function () {
                this.stan = null;
            }, 0);
        },     
        zapiszDoPliku() {
            var state = this.pobierzStan()
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";            
            var json = JSON.stringify(state),
            blob = new Blob([json], {type: "octet/stream"}),
            url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = "makro.txt";
            a.click();
            setTimeout(() => {
                window.URL.revokeObjectURL(url)
                document.body.removeChild(a)
            }, 0)
        },
        wczytajZPliku() {
            var self = this;
            var el = document.createElement("input");
            document.body.appendChild(el);
            el.style = "display: none";
            el.type = "file";            
            el.onchange = function () {
                if (!this.files) return;
                if (this.files.length==0) return;
                var file = this.files[0];
                var reader = new FileReader();
                reader.onload = function () {
                    //scope.$eval(attrs.loadFile, { $file: reader.result });
                    //scope.$digest();
                    self.wczytajStan(reader.result);
                };
                reader.readAsText(file);                
            };
            el.click();
        },
        pobierzStan(){
            var state = [];
            for (var i in this.nawozy) {
                var makro = this.nawozy[i];
                var makroState = {};
                makro.zapisz(makroState);
                state.push(makroState);
            }
            return state;            
        },
        wczytajStan(daneStr) {        
            this.nawozy = [];
            if (daneStr.length > 10000) return;
            var state = JSON.parse(daneStr);
            this.id = 0;            
            for (var i in state) {
                var makroState = state[i];
                var nowy = new Makro();
                nowy.wczytaj(makroState);
                if (this.id<nowy.id)
                    this.id = nowy.id;     
                this.nawozy.push(nowy);
            }
            this.id++;
        },
        zapisz() {
            var state = this.pobierzStan();
            localStorage.setItem("makro", JSON.stringify(state));
        },
        wczytaj() {
            try {            
                this.wczytajStan(localStorage.getItem("makro"));
            }
            catch (e) {
                localStorage.removeItem("makro");
            }        
        },
    }    
}
</script>
<style scoped> 
    span.disabled {
        opacity: 50%;
    }
    .clickable {
        cursor: pointer;
        background-color: #007baa;
        color: white;
    }
    .plate {
        margin: 3px;
        padding: 5px 7px;
        border-radius: 5px;
    }
    .plate.uzywany {
        background-color: green;
    }  
    .md-icon.info {
        color: rgb(221, 165, 12);
    }
    .accent {
        background-color: #8f2f0a;
    } 
</style>
